import { useState, useMemo } from 'react'
import dayjs from 'dayjs'

export function useTableSort(data = [], columns = []) {
  const [sortedColumn, setSortedColumn] = useState(null)
  const [sortedColumnMode, setSortedColumnMode] = useState(0) // 0 = no sort, 1 = asc, 2 = desc

  const sortedData = useMemo(() => {
    const rows = Array.isArray(data) ? data : []

    if (!sortedColumn || sortedColumnMode === 0) return rows

    const colMeta = columns.find((c) => c.name === sortedColumn)

    const compare = (a, b) => {
      let aValue = a?.[sortedColumn]
      let bValue = b?.[sortedColumn]

      if (aValue == null && bValue == null) return 0
      if (aValue == null) return 1
      if (bValue == null) return -1

      if (colMeta?.type === 'date') {
        return dayjs(aValue).valueOf() - dayjs(bValue).valueOf()
      }

      return aValue.toString().localeCompare(bValue.toString(), undefined, { numeric: true })
    }

    const sorted = [...rows].sort(compare)
    return sortedColumnMode === 2 ? sorted.reverse() : sorted
  }, [data, sortedColumn, sortedColumnMode, columns])

  const handleSort = (colName) => {
    if (sortedColumn !== colName) {
      setSortedColumn(colName)
      setSortedColumnMode(1)
    } else {
      setSortedColumnMode((prev) => (prev + 1) % 3) // cycle 0 → 1 → 2
    }
  }

  return {
    sortedData,
    sortedColumn,
    sortedColumnMode,
    handleSort
  }
}
